import { PricingPalette } from './types';

export default Object.freeze([
  'sabaeus',
  'midnight',
  'link',
  'arctic',
  'concord',
  'raspberry',
  'bengal',
  'bumblebee',
  'black',
  'charcoal',
  'slate',
  'stone',
  'flint',
  'pebble',
  'canvas',
  'white',
  'navy',
  'dijon',
]);

export const pricingPalette: Required<PricingPalette> = {
  colors: {
    sabaeus: '#00BF6F',
    midnight: '#05467E',
    link: '#007FAA',
    arctic: '#2DCCD3',
    concord: '#671E75',
    raspberry: '#AC145A',
    bengal: '#F05B24',
    bumblebee: '#F9BE00',
    black: '#000000',
    charcoal: '#333E48',
    slate: '#6B787F',
    stone: '#9DA5AA',
    flint: '#D0D2D3',
    pebble: '#EDEEEE',
    canvas: '#F7F8FA',
    white: '#FFFFFF',
    navy: '#051C4F',
    dijon: '#F7E298',
  },
};
